import { ref } from 'vue'

export function useFileUpload() {
  const fileInput = ref<File | null>(null)
  const fileInputRef = ref<HTMLInputElement | null>(null)

  const onFileSelect = (event: Event) => {
    const target = event.target as HTMLInputElement
    if (target.files?.[0]) {
      fileInput.value = target.files[0]
    }
  }

  const openFileDialog = () => {
    fileInputRef.value?.click()
  }

  const removeFile = () => {
    fileInput.value = null
    if (fileInputRef.value) {
      fileInputRef.value.value = ''
    }
  }

  const resetFile = () => {
    removeFile()
  }

  return {
    fileInput,
    fileInputRef,
    onFileSelect,
    openFileDialog,
    removeFile,
    resetFile,
  }
}
